import { HeaderPositionType } from "../constants";
import { BaseCategory } from "./BaseCategory";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class TeamCategory extends BaseCategory {
    get name() {
        return "Team";
    }

    get type() {
        return SlideCategories.TEAM;
    }

    get icon() {
        return null;
    }

    get description() {
        return "Use for introducing multiple team members, leadership, speakers, or key people with their names, titles, and photos. For a single person biography slide, use the Biography category instead.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Create a team members slide based on the user's prompt.
        Provide information for each team member including their name and role/title.
        You can optionally provide a search term for their headshot photo.
        Specify how many team members should be shown (between 2 and 8).`;
    }

    getPromptSchema() {
        return {
            people: [
                {
                    // name: "Full name of the team member",
                    // role: "Job title or role of the team member",
                    text: "richtext with name, role/title and other information about the team member",
                    photoSearch: "optional search term for headshot photo (e.g., 'professional business person', 'executive portrait')",
                    gender: "male/female"
                }
            ],
            conclusion: "an optional short conclusion or takeaway for the slide",
        };
    }

    validateGeneratedModel(model) {
        if (!this.validateArray(model.people)) {
            return false;
        }
        return true;
    }

    getImagePrompt() {
        return false;
    }

    getSlideModels(model, options = {}) {
        let models = [];
        models.push(this.buildTeamSlide(model, options));
        return models;
    }

    buildTeamSlide(model, options = {}) {
        let builder = new SlideModelBuilder("team", model);

        // Add header if there's a title
        if (model.slideTitle) {
            builder.createHeader({
                heading: model.slideTitle,
                position: HeaderPositionType.TOP
            });
        }

        // Create the primary team element
        builder.createPrimary({
            items: model.people.map(person => ({
                ...builder.createImage(person.photoSearch, { enableFaceDetection: true }),
                text: {
                    blocks: person.text
                }

            }))
        });

        if (options.citeSources) {
            builder.createSourcesAttribution(model.sources);
        }

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion);
        }

        return builder.model;
    }

    enhancePhotoSearch(searchTerm, memberName) {
        // Enhance search term to get better headshots
        // Add context for professional portrait photos
        let enhanced = searchTerm;

        // If the search doesn't already mention professional/portrait context, add it
        if (!searchTerm.match(/professional|portrait|headshot|business/i)) {
            enhanced = `${searchTerm}, professional portrait`;
        }

        // Add face detection friendly terms
        enhanced += ", centered face, well-lit";

        return enhanced;
    }
}
